import { Component } from 'react'
import { observer } from 'mobx-react'
import { browserHistory } from 'react-router'

import * as h from 'h'

import { goToPageWithSubMaybe } from 'utils'

import { menu } from 'config'

import styles from './styles.scss'

const Item = ({ item, open, expanded, expander }) =>
  h.li(h.ca(styles.li),
    h.z({ onClick: () => open(item.slug), ...h.ca(styles.itemLink) }, item.name),
    h.maybe(item.items.length !== 0,
      h.z({ onClick: expander, ...h.ca(styles.caretLink) },
        h.icon({ name: 'caret-down', ...h.ca(styles.caretFa) }))),
    h.clearfix(),
    h.ul(h.ca(styles.ul2, { [styles.ul2Show]: (expanded && item.items.length !== 0) }),
      item.items.map((subItem, i) =>
        h.li({ key: i, ...h.ca(styles.li2) },
          h.z({ onClick: () => open(item.slug, subItem.slug), ...h.ca(styles.li2a) },
            subItem.name)))))

const Items = ({ open, expandedItems, expander }) =>
  h.ul(h.ca(styles.ul),
    menu
    .filter(({ hidden, landingOnly }) => !hidden && !landingOnly)
    .map(item =>
      h.h(Item, {
        key: item.slug,
        expanded: expandedItems.includes(item.slug),
        expander: () => expander(item.slug),
        open,
        item
      })))

@observer(['UiStore'])
export default class Menu extends Component {
  close () {
    this.props.UiStore.toggleMenu()
  }

  get show () {
    return this.props.UiStore.showMenu
  }

  expander (itemSlug) {
    this.props.UiStore.toggleMenuItemExpanded(itemSlug)
  }

  open (itemSlug, subItemSlug = null) {
    this.close()

    // NOTE if in the future you want to revert back to
    // the original and [more sane in my opinion]
    // menu-item-opens-resource (and not landing page),
    // just get rid of the below conditional and forward
    // args to goToPageWithSubMaybe (as the first branch is)

    if (subItemSlug || (itemSlug !== 'explore' && itemSlug !== 'twitter')) {
      goToPageWithSubMaybe(itemSlug, subItemSlug)
    } else {
      // Open landing

      // Set panel to scroll to next
      this.props.UiStore.scrollToLandingPanelNext = itemSlug

      browserHistory.push('/')
    }
  }

  render () {
    return h.div(h.ca(styles.menu, { [styles.menuShow]: this.show }),
      h.z({ onClick: ::this.close, ...h.ca(styles.close) }, '×'),
      h.nav(null,
        h.h(Items, {
          open: ::this.open,
          expandedItems: this.props.UiStore.expandedMenuItems.toJS(),
          expander: ::this.expander
        })))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Menu/index.js